<template>
  <div class="recordings">
    <div v-if="!loadingRecordings && recordings.length > 0">
      <div v-for="audio in recordings" :key="audio.id" class="pt-3">
        <Recording
          :audio="audio"
          :section="section"
          @deleted="removeRecording(audio.guid, audio.id)"
        />
      </div>
    </div>
    <p
      v-if="!loadingRecordings && recordings.length === 0"
      class="has-text-grey has-text-centered"
    >
      You have no recordings for this section.
    </p>
    <p v-if="loadingRecordings" class="has-text-grey has-text-centered">
      Loading your recordings...
    </p>
  </div>
</template>

<script>
import Recording from "@/components/Recording";
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["section"],
  components: { Recording },
  computed: {
    ...mapGetters(["getRecordings"]),
    recordings() {
      return (
        this.getRecordings(this.section.id)?.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        ) ?? []
      );
    }
  },
  data() {
    return {
      loadingRecordings: false
    };
  },
  methods: {
    ...mapActions(["fetchRecordingsAction", "deleteRecording"]),
    async loadRecordings() {
      if (this.section === undefined) return;
      this.loadingRecordings = true;
      const recordings = this.getRecordings(this.section.id);
      if (recordings === undefined) {
        await this.fetchRecordingsAction({
          sectionId: this.section.id
        });
      }
      this.loadingRecordings = false;
    },
    async removeRecording(audioGuid, audioId) {
      await this.deleteRecording({
        sectionId: this.section.id,
        audioId: audioId,
        audioGuid: audioGuid
      });
    }
  },
  async created() {
    await this.loadRecordings();
  }
};
</script>

<style lang="scss" scoped></style>
